import React from 'react';
import { Modal, Button, Checkbox, Form, Select, InputNumber, Input, Radio, Statistic, Table, DatePicker } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import dayjs from 'dayjs';
import { EditableRow, EditableCell } from './EditableTable';
import { tableCSS, formatNumber2point } from './utils';

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const bangkokTimezone = "Asia/Bangkok"

const CreateOrderModal = ({
    isModalOpen,
    handleModalCancle,
    handleCreateOrder,
    checkCart,
    isEmployeeUnlock,
    onCheckChange,
    form,
    formRef,
    onFinish,
    option,
    select,
    calculateTempPrice,
    employeeoption,
    employeeoptionWithFilter,
    calculateTempPriceForpercentage,
    calculateTempPriceForValue,
    selectedUsedOptions,
    setSelectedUsedOption,
    cart,
    columns,
    form3,
    setIsPayOptionsSelected,
    setIsAdditionalDiscountValid,
    setAdditionalDiscount,
    totalPrice,
    cdiscount,
    finalprice,
    additionalDiscount,
    authState
}) => {
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    return (
        <Modal width={1000} title="สร้างรายการ" open={isModalOpen} onCancel={handleModalCancle} footer={
            [
                <Button
                    key="ok" onClick={handleCreateOrder} disabled={!checkCart()} >ตกลง
                </Button>
                , <Button key="close" onClick={handleModalCancle}>ปิด</Button>]}>
            <Checkbox checked={isEmployeeUnlock} onChange={onCheckChange}>ปลดล็อคพนักงาน[สำหรับพนักงานต่างสาขา]</Checkbox>
            <Form name="basic"
                ref={formRef}
                form={form}
                onFinish={onFinish}
                autoComplete="off"
                layout='vertical'
                className=' flex flex-col'
            >
                <div className='flex'>
                    <div className='flex-1'>
                        <Form.Item name="id" label="รายการ" rules={[{ required: true, message: 'กรุณาเลือกรายการบริการ' }]} style={{ marginBottom: "10px" }}>
                            <Select
                                showSearch
                                placeholder="Select"
                                options={option}
                                allowClear
                                filterOption={(inputValue, option) =>
                                    (option.label && option.label.toLowerCase().includes(inputValue.toLowerCase())) ||
                                    (option.value && option.value.toString().toLowerCase().includes(inputValue.toLowerCase()))
                                }
                                onChange={(selectedValue, selectedOption) => {
                                    select(selectedValue, selectedOption);
                                    calculateTempPrice();
                                }}
                            />
                        </Form.Item>
                    </div>

                    <Form.Item style={{ marginBottom: "10px" }} name="times" label="จำนวน" rules={[
                        {
                            type: 'number',
                            min: 1,
                            max: 100,
                            message: 'จำนวนต้องอยู่ระหว่าง 0 ถึง 100 เท่านั้น',
                        },
                    ]} >
                        <InputNumber defaultValue={0} onChange={calculateTempPrice} />
                    </Form.Item>
                </div>

                <div className='flex'>
                    <div className='flex-1'>
                        <Form.Item name="price" label="ราคา" style={{ marginBottom: "10px" }} >
                            <Input placeholder="ราคา" readOnly={true} defaultValue={0} />
                        </Form.Item>
                    </div>

                    <Form.Item name="tempPrice" label="ราคารวมส่วนลด" style={{ marginBottom: "10px" }} >
                        <Input placeholder="ราคา" readOnly={true} defaultValue={0} />
                    </Form.Item>
                </div>

                <Form.Item name="inviter_id" label="ผู้แนะนำ" rules={[{ required: true, message: 'กรุณาเลือกชื่อผู้แนะนำ' }]} style={{ marginBottom: "0px" }}>
                    <Select options={isEmployeeUnlock ? employeeoption : employeeoptionWithFilter} placeholder="กรุณาเลือกผู้แนะนำ" showSearch
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase()) ||
                            option.value.toString().toLowerCase().includes(input.toLowerCase())
                        } />
                </Form.Item>

                <Form.Item name="inviter_percent"
                    label="เปอเซนต์แนะนำ"
                    rules={[{ required: true, message: 'กรุณาเลือกชื่อผู้แนะนำ' }]}
                    style={{ marginBottom: "0px" }}>
                    <Radio.Group>
                        <Radio value="1" > 1% </Radio>
                        <Radio value="2" > 2% </Radio>
                        <Radio value="3"> 3% </Radio>
                        <Radio value="4"> 4% </Radio>
                        <Radio value="0" > ไม่มี</Radio>
                    </Radio.Group>
                </Form.Item>



                <div className='flex gap-5 '>
                    <div className='flex-1 flex '>
                        <Form.Item style={{ marginBottom: "10px" }}
                            name="discount"
                            label="ส่วนลด %"
                            rules={[
                                {
                                    validator: (_, value) => {
                                        if (value === undefined || value === null) {
                                            return Promise.reject(new Error('กรุณาใส่ส่วนลดในช่วง 0 ถึง 100 '));
                                        }
                                        const numberValue = Number(value);
                                        if (isNaN(numberValue)) {
                                            return Promise.reject(new Error('ส่วนลดต้องเป็นตัวเลขเท่านั้น'));
                                        }
                                        if (numberValue < 0 || numberValue > 100) {
                                            return Promise.reject(new Error('ส่วนลดต้องอยู่ในช่วง 0 ถึง 100'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="โค้ดส่วนลด" onChange={calculateTempPriceForpercentage} />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: "10px" }}
                            name="discountV"
                            label="ส่วนลด"
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator: (_, value) => {
                                        const tempPrice = formatNumber2point((parseFloat(getFieldValue('price')) * parseFloat(getFieldValue('times'))))
                                        if (value === undefined || value === null) {
                                            return Promise.reject(new Error('กรุณาใส่ส่วนลดที่เป็นตัวเลข'));
                                        }
                                        const numberValue = Number(value);
                                        if (isNaN(numberValue)) {
                                            return Promise.reject(new Error('ส่วนลดต้องเป็นตัวเลขเท่านั้น'));
                                        }
                                        if ((numberValue < 0) || (numberValue > tempPrice)) {
                                            return Promise.reject(new Error(`ส่วนลดต้องมากกว่า 0 เเละน้อยกว่า ${tempPrice}`));
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input placeholder="ส่วนลด" onChange={calculateTempPriceForValue} />
                        </Form.Item>
                    </div>
                </div>

                <Form.Item style={{ marginBottom: "10px" }}
                    label="ราคาที่จะจ่าย"
                    name="price_to_paid"

                    rules={[
                        {
                            required: true,
                            message: 'กรุณาใส่ราคาที่จะจ่าย ',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (value !== null && value !== undefined) {
                                    const totalPrice = formatNumber2point((parseFloat(getFieldValue('price')) * parseFloat(getFieldValue('times')) * (1 - parseFloat(getFieldValue('discount') / 100))))
                                    if (totalPrice < value) {
                                        return Promise.reject(new Error(`ราคาที่จะจ่ายมากกว่าราคาสินค้า [ราคาสินค้ารวมส่วนลด ${totalPrice}]`))
                                    } else if (value < 0) {
                                        return Promise.reject(new Error(`ราคาที่จะจ่ายห้ามน้อยกว่า 0 `))
                                    }
                                    else if (getFieldValue('times_to_use')) {
                                        if (parseInt(getFieldValue('times')) - parseInt(getFieldValue('times_to_use')) <= 0 && (parseFloat(totalPrice) !== parseFloat(value))) {
                                            return Promise.reject(new Error(`กรุณาชำระเงินให้ครบก่อนใช้บริการครบทุกครั้ง [ราคาสินค้ารวมส่วนลด ${totalPrice}]`))
                                        }
                                        else {
                                            return Promise.resolve();
                                        }
                                    }
                                    else {
                                        return Promise.resolve();
                                    }
                                } else {
                                    return Promise.resolve();
                                }
                            }
                        }),
                    ]}
                >
                    <InputNumber className='w-full' placeholder='กรุณาใส่ราคาที่จะจ่าย' />
                </Form.Item>

                <Form.Item style={{ marginBottom: "10px" }}
                    label="ตัวเลือกการใช้บริการ"
                    name="use_options"
                    rules={[
                        {
                            required: true,
                            message: 'กรุณาเลือกตัวเลือกการใช้บริการ',
                        },
                    ]}
                >
                    <Radio.Group onChange={(e) => setSelectedUsedOption(e.target.value)} >
                        <Radio value={0} > ยังไม่ใช้ </Radio>
                        <Radio value={1}> ใช้เลย </Radio>
                        {selectedUsedOptions === 1 && (
                            <div className='flex gap-10'>
                                <Form.Item name="healthcare_provider_id" label="ผุ้ทำการรักษา [เลือกสูงสุด 3 คน]" rules={[{ required: true, message: 'กรุณาเลือกชื่อผู้แนะนำ' }]} style={{ marginBottom: "0px", marginTop: "10px" }}>
                                    <Select options={isEmployeeUnlock ? employeeoption : employeeoptionWithFilter} placeholder="กรุณาเลือกรักษา" showSearch mode="multiple" maxTagCount={3}
                                        filterOption={(input, option) =>
                                            option.label.toLowerCase().includes(input.toLowerCase()) ||
                                            option.value.toString().toLowerCase().includes(input.toLowerCase())
                                        }
                                        onChange={value => {
                                            if (value?.length > 3) {
                                                value.pop();
                                            }

                                        }}
                                    />
                                </Form.Item>
                                <Form.Item name="times_to_use" label="จำนวนที่ใช้"
                                    rules={[{
                                        required: true, message: 'กรุณาใส่จำนวนครั้ง'
                                    },
                                    {
                                        type: 'number',
                                        min: 1,
                                        message: 'จำนวนต้องมากกว่าหรือเท่ากับ 1'
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (value !== null && value !== undefined) {
                                                if (parseFloat(getFieldValue('times')) >= value) {
                                                    return Promise.resolve();
                                                } else {
                                                    return Promise.reject(new Error('จำนวนที่ใช้มากกว่าสินค้า'));
                                                }
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    }),
                                    ]}


                                    style={{ marginBottom: "0px", marginTop: "10px" }}>
                                    <InputNumber placeholder='จำนวนครั้ง' />
                                </Form.Item>

                                <Form.Item name="handfee_times"
                                    label="จำนวนครั้งของค่ามือ"
                                    rules={[
                                        { required: true, message: 'กรุณาใส่จำนวนครั้งของค่ามือ' },
                                        {
                                            type: 'number',
                                            min: 0,
                                            max: 100,
                                            message: 'จำนวนต้องอยู่ระหว่าง 0 ถึง 100 เท่านั้น',
                                        },
                                    ]}
                                    style={{ marginBottom: "0px", marginTop: "10px" }}>
                                    <InputNumber placeholder='จำนวนครั้งของค่ามือ'></InputNumber>
                                </Form.Item>
                            </div>
                        )}
                    </Radio.Group>
                </Form.Item>




                <Form.Item className='flex justify-center' >
                    <Button htmlType="submit">
                        เพิ่มรายการ
                    </Button>
                </Form.Item>

            </Form>

            <Table components={components} rowClassName={() => 'editable-row'} columns={columns} dataSource={cart} pagination={{ pageSize: 3 }} size="small" rowKey="id" className={tableCSS} scroll={{ x: 'auto' }} />

            <Form form={form3}>
                <Form.Item style={{ marginBottom: "10px" }}
                    label="วิธีการชำระเงิน"
                    name="payment_method"
                    rules={[
                        {
                            required: true,
                            message: 'กรุณาเลือกประเภท',
                        },
                    ]}
                >
                    <Radio.Group onChange={() => { setIsPayOptionsSelected(true) }}>
                        <Radio value="เงินสด"> เงินสด </Radio>
                        <Radio value="โอนธนาคาร"> โอนธนาคาร </Radio>
                        <Radio value="บัตรเครดิต/เดบิต"> บัตรเครดิต/เดบิต </Radio>
                        <Radio value="ไม่มี"> ไม่มี</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>

            <Form
                form={form3}
                initialValues={{ date: dayjs().tz(bangkokTimezone) }}
            >
                <Form.Item style={{ marginBottom: "10px" }}
                    label="ส่วนลดเพิ่มเติม"
                    name="additional_discount"
                    rules={[
                        {
                            type: Number,
                            required: false,
                        },
                        ({ getFieldValue }) => ({

                            validator: (_, value) => {
                                if (value === undefined || value === null) {
                                    setIsAdditionalDiscountValid(false)
                                    return Promise.reject(new Error(`ส่วนลดต้องอยู่ในช่วง 0 ถึง  ${priceValue} `));
                                }
                                const numberValue = Number(value);
                                const priceValue = Number((cart.reduce((acc, item) => acc + (item.price_to_paid), 0)))
                                if (isNaN(numberValue)) {
                                    setIsAdditionalDiscountValid(false)
                                    return Promise.reject(new Error('ส่วนลดต้องเป็นตัวเลขเท่านั้น'));
                                }
                                if (numberValue < 0 || numberValue > priceValue) {
                                    setIsAdditionalDiscountValid(false)
                                    return Promise.reject(new Error(`ส่วนลดต้องอยู่ในช่วง 0 ถึง ${priceValue} `));
                                }
                                setIsAdditionalDiscountValid(true)
                                return Promise.resolve();
                            }
                        }),
                    ]}
                >
                    <InputNumber placeholder='ส่วนลดเพิ่มเติม' onChange={(value) => { setAdditionalDiscount(value) }} />
                </Form.Item >
                <Form.Item style={{ marginBottom: "10px" }}
                    label="หมายเหตุ"
                    name="remark"
                    rules={[
                        {
                            max: 200,
                            message: 'หมายเหตุต้องไม่เกิน 200 ตัวอักษร',
                        },
                    ]}>
                    <TextArea style={{ width: "20rem" }} maxLength={200}>
                    </TextArea>
                </Form.Item>

                <Form.Item name="date" label="วันที่" rules={[{ required: true, message: 'กรุณาเลือกวันที่' }]} style={{ marginBottom: "10px" }}>
                    <DatePicker
                        className="custom-datepicker"
                        disabledDate={(current) => current && current > moment().endOf('day')}
                        disabledTime={(current) => {
                            const now = moment();
                            if (current && current.isSame(now, 'day')) {
                                return {
                                    disabledHours: () => Array.from({ length: 24 }, (_, i) => i).splice(now.hour() + 1),
                                    disabledMinutes: () => Array.from({ length: 60 }, (_, i) => i).splice(now.minute() + 1),
                                    disabledSeconds: () => Array.from({ length: 60 }, (_, i) => i).splice(now.second() + 1),
                                };
                            }
                            return {};
                        }}
                        format="YYYY-MM-DD HH:mm"
                        showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm') }}
                        disabled={authState.role !== 'admin'}
                    />
                </Form.Item>
            </Form>
            <div className='flex '>
                <Statistic title="ราคาสุทธิ" value={totalPrice} precision={2} className='pr-10' />
                <Statistic title="ส่วนลด" value={cdiscount} precision={2} className='pr-10' />
                <Statistic title="ราคารวม" value={finalprice - parseFloat(additionalDiscount || 0)} precision={2} />
            </div>
        </Modal>
    );
};

export default CreateOrderModal;
